import React from "react";
import API from "@beardeddevops/react.api";
import Types from "constants/Types";
import Framework from "@beardeddevops/react.framework";
import ReactTable from "react-table";
import Card from "@material-ui/core/Card";
import CardContent from "@material-ui/core/CardContent";
import moment from "moment";
import {Objects} from "../index";
import {buildAuditWorkOrderColumns} from "../../utilities/auditWorkOrders/columns";
import {getTicketFinancial} from "../../utilities/auditWorkOrders/financialDisplay";

const TABLE_PREFERENCES_KEY = "table-preferences-AuditWorkOrders";
const AUDIT_WORK_ORDERS_BASE_URL = "/financial/audit_work_orders";

export default class AuditWorkOrders extends Framework.Components.Collection {
	constructor(props) {
		const model = new API.BuildClass(Types.Tickets._name, API.RequestType.READ_ALL);
		super(props, model);
		this.state = {
			...this.state,
			limit: 16,
			showFinancialModal: false,
			selectedTicketPkey: null,
			selectedFinancialPkey: null,
		};
	}

	componentDidMount() {
		const todayStart = moment().format("YYYY-MM-DD 00:00:00");
		const todayEnd = moment().format("YYYY-MM-DD 23:59:59");
		localStorage.setItem(
			TABLE_PREFERENCES_KEY,
			JSON.stringify({
				default: {
					filter: {date: [{start: todayStart, end: todayEnd}]},
					startDate: todayStart,
					endDate: todayEnd,
				},
			})
		);
	}

	openFinancialModal = (ticket) => {
		const financial = getTicketFinancial(ticket);
		if (!financial?.pkey) return;
		this.setState({
			selectedTicketPkey: ticket.pkey,
			selectedFinancialPkey: financial.pkey,
			showFinancialModal: true,
		});
	};

	closeFinancialModal = () => {
		this.setState(
			{
				showFinancialModal: false,
				selectedTicketPkey: null,
				selectedFinancialPkey: null,
			},
			() => this.fetchData()
		);
	};

	toggleFinancialApproved = async (ticket, financial) => {
		if (!financial?.pkey) return;
		const ticketId = financial.ticket ?? ticket?.pkey;
		if (!ticketId) return;

		const model = new API.BuildClass(Types.Tickets_Financials._name, "POST");
		model.parent = ticketId;
		model.object = {
			...financial,
			ticket: ticketId,
			parent: ticketId,
			approved: !financial.approved,
		};
		await model.submit(null, "POST");
		await this.fetchData();
	};

	renderFinancialModal() {
		const {showFinancialModal, selectedTicketPkey, selectedFinancialPkey} = this.state;
		return (
			<Framework.Elements.UniversalModal
				size="md"
				parent={selectedTicketPkey}
				id={selectedFinancialPkey}
				history={this.props.history}
				object={Objects.Financial}
				title="Edit Financial"
				showModal={showFinancialModal}
				reportClose={this.closeFinancialModal}
				afterSave={this.closeFinancialModal}
				hasDelete={false}
				hasSubmit={false}
				hasCancel={false}
				hideGoTo={true}
				objectProps={{
					hideBack: true,
					baseUrl: AUDIT_WORK_ORDERS_BASE_URL,
					reloadPage: this.closeFinancialModal,
					closeModal: this.closeFinancialModal,
				}}
			/>
		);
	}

	render() {
		const {data, pages, limit, loading} = this.state;
		const columns = buildAuditWorkOrderColumns({
			onEditFinancial: this.openFinancialModal,
			onToggleValid: this.toggleFinancialApproved,
		});

		return (
			<Card>
				<CardContent>
					<div className="table-bar">
						<div className="d-flex">
							{this.renderSearch("Audit Work Orders", "")}
							{this.renderDateRangeSearch()}
							{this.renderHeaderRight("Audit_Work_Orders", columns)}
						</div>
					</div>
					<ReactTable
						key={this.state.key}
						columns={columns}
						manual
						data={data}
						pages={pages}
						loading={loading}
						loadingText="Requesting Data"
						onFetchData={this.fetchData}
						expanderDefaults={{
							sortable: true,
							resizable: true,
							filterable: false,
							width: undefined,
						}}
						showPagination={true}
						defaultPageSize={limit}
						className="-striped -highlight"
						onPageSizeChange={this.onPageSizeChange}
						pageSize={limit}
						pageSizeOptions={[5, 20, 50, 100, 500, 1000, 10000]}
					/>
					{this.renderFinancialModal()}
					<Framework.Elements.LoadingSpinner isLoading={loading} />
				</CardContent>
			</Card>
		);
	}
}
